<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table :headers='headers' :items='itens' class='elevation-1' :loading='loading'
          loading-text="Loading... Please wait" :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v">
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-col cols="2">
                <v-row>
                  <v-text-field value="value.storepass" name="storepass" label="Storepass"
                    v-model="valueStorepass.storepass" />
                </v-row>
              </v-col>
              <v-btn color='primary' dark class='mb-2 mx-2' @click="saveItemStorepass">Alterar Storepass</v-btn>

              <v-spacer></v-spacer>
              <v-btn color='primary' dark class='mb-2 mx-2' @click="playJks()" :disabled="disableGenJKS">Gerar Jks
              </v-btn>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class='mb-2' color="primary" dark v-bind="attrs" v-on="on">
                    Downloads
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-btn color='primary' class="mx-4" dark @click="downloadJks()">
                      JKS
                    </v-btn>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color='primary' class="mx-4" dark @click="downloadLog()">
                      Log
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <template>
              <v-toolbar flat color='white'>
                <v-col cols="2">
                  <v-row>
                    <v-text-field name="host" label="Host:Port" v-model="valueHost.host" />
                  </v-row>
                </v-col>
                <v-btn color='primary' dark class='mb-2 mx-2' @click="SaveItemHost">Adicionar Host</v-btn>
              </v-toolbar>
            </template>
            <template>
              <div class="modal-overlay" v-if="showModal">
                <div class="modal">
                  <v-progress-circular class='mb-6' indeterminate color="primary"></v-progress-circular>
                  <p>Iniciado geração JKS... Aguarde concluír processo!</p>
                </div>
              </div>
            </template>
          </template>

          <template v-slot:item.expdate='{ item }'>
            <p v-if="item.expdate">{{ formatDate(item.expdate) }}</p>
            <v-icon small v-else>mdi-blur</v-icon>
          </template>
          <template v-slot:no-data>
            Nenhum dado encontrado
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/TruststoreService'
import LocalStorageService from '@/services/LocalStorageService'
import moment from 'moment'

export default {
  data: () => ({
    headers: [
      {
        text: 'Host',
        value: 'host',
        sortable: true
      },
      {
        text: 'Data de Validade',
        value: 'expdate',
        sortable: true,
        align: 'start'
      }
    ],
    itens: [],
    loading: true,
    showModal: false,
    valueHost: {
      host: '',
      client: LocalStorageService.getClientPrefix()
    },
    valueStorepass: {
      storepass: '',
      client: LocalStorageService.getClientPrefix()
    },
    disableGenJKS: false
  }),

  mounted () {
    this.searchHost()
    this.searchStorepass()
  },

  computed: {
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('user_per_page') ? parseInt(this.$cookies.get('user_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('user_per_page', value)
      }
    }
  },

  methods: {
    formatDate (date) {
      if (date) {
        return moment(String(date)).format('DD/MM/YYYY HH:mm:ss')
      }
    },

    searchHost () {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      Servico.findAllHost(clientUrlPrefix)
        .then((result) => {
          this.itens = result.data
          this.loading = false
        })
    },

    searchStorepass () {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      Servico.findAllStorepass(clientUrlPrefix)
        .then((result) => { this.valueStorepass.storepass = result.data[0]?.storepass })
    },

    SaveItemHost () {
      Servico.insertHost(this.valueHost)
        .then(() => location.reload())
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    saveItemStorepass () {
      Servico.insertStorepass(this.valueStorepass)
        .then(() => location.reload())
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    downloadJks () {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      Servico.downloadJks(clientUrlPrefix)
    },

    downloadLog () {
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      Servico.downloadLog(clientUrlPrefix)
    },

    playJks () {
      this.disableGenJKS = true
      const clientUrlPrefix = LocalStorageService.getClientPrefix()
      this.showModal = true
      Servico.playJks(clientUrlPrefix)
        .finally(() => {
          this.disableGenJKS = false
          this.showModal = false
        })
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    }
  }
}
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    background-color: rgba(0,0,0,0.5);
  }

  .modal {
    text-align: center;
    background-color: white;
    height: 350px;
    width: 350px;
    margin-top: 10%;
    padding: 60px 0;
    border-radius: 20px;
  }
  </style>
